export enum KinderLeistung {
    KINDERGELD= 'Kindergeld',
    KINDERZUSCHLAG='Kinderzuschlag'
}